import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmployeeReportComponent } from './employee-report/employee-report.component';
import { NotasFiscaisReportComponent } from './notas-fiscais-report/notas-fiscais-report.component';
import { FinantialReportComponent } from './finantial-report/finantial-report.component';
import { ProfessionalTransfersReportComponent } from './professional-transfers-report/professional-transfers-report.component';
import { ServiceReportComponent } from './service-report/service-report.component';
import { FinantialReceiptsReportComponent } from './finantial-receipts-report/finantial-receipts-report.component';
import { FinantialExpensesReportComponent } from './finantial-expenses-report/finantial-expenses-report.component';
import { pageAccessGuard } from '../guard/page-access.guard';
import { BankingReportComponent } from './banking-report/banking-report.component';

const routes: Routes = [
  {
    path: 'funcionario', component: EmployeeReportComponent,
    canActivate: [pageAccessGuard],
    data: {
      access: 'funcionarioReport'
    }
  },
  {
    path: 'notasFiscais', component: NotasFiscaisReportComponent,
    canActivate: [pageAccessGuard],
    data: {
      access: 'notasFiscaisReport'
    }
  },
  {
    path: 'repassesProfissionais', component: ProfessionalTransfersReportComponent,
    canActivate: [pageAccessGuard],
    data: {
      access: 'repassesProfissionaisReport'
    }
  },
  {
    path: 'financeiro', component: FinantialReportComponent
    /*,
    canActivate: [pageAccessGuard],
    data: {
      access: 'financeiroReport'
    }*/
  },
  {
    path: 'financeiro/receita', component: FinantialReceiptsReportComponent,
    canActivate: [pageAccessGuard],
    data: {
      access: 'financeiroReport'
    }
  },
  {
    path: 'financeiro/despesa', component: FinantialExpensesReportComponent,
    canActivate: [pageAccessGuard],
    data: {
      access: 'financeiroReport'
    }
  },
  {
    path: 'atendimentos', component: ServiceReportComponent,
    canActivate: [pageAccessGuard],
    data: {
      access: 'atendimentosReport'
    }
  },
  {
    path: 'bancario',
    component: BankingReportComponent,
    //canActivate: [pageAccessGuard],
    data: {
      access: 'bankingReport'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
